<template>
  <base-card>
    <h2>Teams List</h2>
    <base-card>
      <ul>
        <li v-for="conference in conferenceNames" :key="conference">
          <h3>{{ conference }}</h3>
          <ul>
            <li v-for="division in divisionNames" :key="division">
              <h4>{{ division }}</h4>
              <ul>
                <li v-for="team in teamsByDivision(conference, division)" :key="team.name">
                  {{ team.teamId }}: {{ team.name }}
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </base-card>
  </base-card>
</template>

<script>
export default {
  computed: {
    currentTeamsList() {
      return this.$store.getters["teams/currentTeamsList"];
    },
  },
  data() {
    return {
      conferenceNames: ["AFC", "NFC"],
      divisionNames: ["East", "North", "South", "West"],
    };
  },
  methods: {
    teamsByDivision(conference, division) {
      return this.currentTeamsList.filter((team) => {
        return team.conference === conference && team.division === division;
      });
    },
  },
};
</script>
